import { render, staticRenderFns } from "./GetPictureFromCameraPwaBtn.vue?vue&type=template&id=0df4914d&scoped=true&"
import script from "./GetPictureFromCameraPwaBtn.vue?vue&type=script&lang=js&"
export * from "./GetPictureFromCameraPwaBtn.vue?vue&type=script&lang=js&"
import style0 from "./GetPictureFromCameraPwaBtn.vue?vue&type=style&index=0&id=0df4914d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df4914d",
  null
  
)

export default component.exports